import React, { useMemo } from 'react';

import type { SideBySideExperiment } from '@atlassian/search-experiment';

import {
	SearchPage as SearchPageRelay,
	type SearchPageProps as SearchPageRelayProps,
} from './search-page-relay';

export function SearchPage(props: SearchPageRelayProps): React.JSX.Element {
	return <SearchPageRelay {...props} />;
}

export type SearchPageSideBySideProps = SearchPageRelayProps & {
	experiments?: SideBySideExperiment[];
};

export function SearchPageSideBySide({
	shell,
	experiments,
	...props
}: SearchPageSideBySideProps): React.JSX.Element {
	const shellWithSideBySide = useMemo(
		() => ({
			...shell,
			features: {
				sideBySide: {
					enabled: true,
					experiments,
				},
			},
		}),
		[shell, experiments],
	);
	return <SearchPageRelay {...props} shell={shellWithSideBySide} />;
}
